import { render, staticRenderFns } from "./HeaderAuth.vue?vue&type=template&id=7b05671e"
import script from "./HeaderAuth.vue?vue&type=script&lang=ts"
export * from "./HeaderAuth.vue?vue&type=script&lang=ts"
import style0 from "./HeaderAuth.vue?vue&type=style&index=0&id=7b05671e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports